<script>
import TextInput from "../../../Shared/TextInput.vue";
import TabLayout from "../Shared/TabLayout.vue";

export default {
    name: "Edit",
    metaInfo: { title: Lang.get('employeedashboard::pages/settings/primary-email.title') },
    components: { TabLayout, TextInput },
    props: {
        current_email: String,
        errors: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                email: null,
                password: null,
            }),
        }
    },
    methods: {
        submit() {
            this.form.post(
                this.route('nl.employeedashboard.settings.primary-email.update')
            )
        },
    }
}
</script>

<template>
    <TabLayout
        :title="Lang.get('employeedashboard::pages/settings/primary-email.title')"
        :subtitle="Lang.get('employeedashboard::pages/settings/primary-email.subtitle')"
        tabName="account"
    >
        <p>
            {{ Lang.get('employeedashboard::pages/settings/primary-email.edit.explanation') }}
        </p>
        <form @submit.prevent="submit">
            <text-input
                class="w-75 mb-4"
                id="email"
                v-model="form.email"
                type="email"
                :label="Lang.get('employeedashboard::pages/settings/primary-email.edit.form.email.label')"
                :error="errors.email"
                :placeholder="Lang.get('employeedashboard::pages/settings/primary-email.edit.form.email.placeholder_prefix') + ' ' + current_email"
            />
            <text-input
                class="w-75"
                id="password"
                v-model="form.password"
                type="password"
                :label="Lang.get('generic.password')"
                :error="errors.password"
            />
            <div class="d-flex mt-4 align-items-center">
                <button type="submit" class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4 mr-2">
                    {{ Lang.get('generic.save') }}
                </button>
            </div>
        </form>
    </TabLayout>
</template>
